import api from '~/api'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  async getClicksNew(_, params = {}) {
    const [, response] = await api.post('/dashboard-data', params)

    return response
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
